<script>
  import Icon from "./Icon.svelte";
</script>

<Icon>
  <title>Icon: pen</title>
  <path
    d="M9.50378191,20.2926264 L3.7073736,14.4962181 L15.9238664,2.27972531 L21.7164948,8.0742437 L9.50378191,20.2926264 Z M3.00243056,16.4636328 L7.53825708,20.9994594 L2.09715518,21.9066247 L3.00243056,16.4636328 Z M16.5910109,0.276401929 C16.2243649,-0.0921339763 15.6252578,-0.0921339763 15.254832,0.276401929 L1.70405022,13.8290736 C1.56608549,13.9670383 1.47347903,14.1503613 1.43946033,14.341244 L0.0125649068,22.8988367 C-0.0365732139,23.1993352 0.0598130998,23.5055035 0.277154787,23.7228452 C0.456697921,23.9023883 0.696718741,23.9987747 0.9461892,23.9987747 C0.997217248,23.9987747 1.05013522,23.9949948 1.10116327,23.9855452 L9.65875599,22.5586497 C9.85341854,22.526521 10.0329617,22.4358044 10.1709264,22.2959498 L23.7235981,8.74138818 C24.092134,8.37285228 24.092134,7.77374519 23.7235981,7.40520929 L16.5910109,0.276401929 Z"
  />
</Icon>
